import api from "./base-api"

const tohPlayerEventApiV1 = api.injectEndpoints({
    endpoints: (build) => ({
        getPlayerEventsV1Toh: build.query({
            query: ({
                userId = "",
                from,
                to
            }) => `v1/toh/player-events/${userId}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
            keepUnusedDataFor: 300
        })
    }),
    overrideExisting: false
})

export const {
    useGetPlayerEventsV1TohQuery
} = tohPlayerEventApiV1
